import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import API_BASE_URL from '../../../../config/api'
import axios from 'axios'
import Swal from 'sweetalert2'
import Topbar from '../../mini-comp/Topbar'
import Sidebar from '../../mini-comp/Sidebar'
import {
    RiDeleteBin2Line,
    RiEdit2Fill,
    RiEye2Line,
    RiPlayFill,
    RiSearchLine,
    RiUserLine,
    RiErrorWarningLine,
    RiLoader4Line
} from 'react-icons/ri'

const RunPayroll = () => {
    const navigate = useNavigate()
    const [employees, setEmployees] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [searchTerm, setSearchTerm] = useState('')
    const [runPayrollLoading, setRunPayrollLoading] = useState(false)
    const [selectedMonth, setSelectedMonth] = useState(() => {
        const now = new Date()
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
    })


    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        try {
            const token = Cookies.get('token')
            // Using the payroll API as per the snippet for employee listing
            const response = await axios.get(`${API_BASE_URL}/api/v1/employees/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
            setEmployees(response.data)
            setError(null)
        } catch (error) {
            console.error('Error fetching data:', error)
            setError('Failed to fetch data. Please try again later.')
        } finally {
            setLoading(false)
        }
    }

    const handleRunPayroll = async () => {
        setRunPayrollLoading(true)
        try {
            const token = Cookies.get('token')
            const month = `${selectedMonth}-01`

            // Using the exact endpoint from the provided snippet
            await axios.post(`${API_BASE_URL}/api/v1/payroll/runs/`, {
                month: month
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            })

            Swal.fire({
                title: 'Success!',
                text: 'Payroll has been processed successfully.',
                icon: 'success',
                timer: 2000,
                showConfirmButton: false
            })
            navigate('/hr/payroll/history')
        } catch (err) {
            console.error(err)
            Swal.fire({
                title: 'Error!',
                text: `${err.response?.data?.error || 'Failed to process payroll. Please try again.'}`,
                icon: 'error',
                confirmButtonColor: '#dc3545'
            })
        } finally {
            setRunPayrollLoading(false)
        }
    }

    const filteredEmployees = employees.filter(employee => {
        const fullName = `${employee.first_name || ''} ${employee.last_name || ''}`.toLowerCase()
        const department = (employee.department_name || '').toLowerCase()
        const search = searchTerm.toLowerCase()
        return fullName.includes(search) || department.includes(search)
    })

    if (loading) {
        return (
            <div>
                <Topbar />
                <Sidebar />
                <div className="app-content-area">
                    <div className="app-content-wrap">
                        <div className="container-fluid">
                            <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
                                <RiLoader4Line className="spinner-border text-primary fs-1 mb-3" style={{ border: 'none', animation: 'spin 1s linear infinite' }} />
                                <p className="text-muted">Loading employees...</p>
                            </div>
                        </div>
                    </div>
                </div>
                <style>{`
                    @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                `}</style>
            </div>
        )
    }

    if (error) {
        return (
            <div>
                <Topbar />
                <Sidebar />
                <div className="app-content-area">
                    <div className="app-content-wrap">
                        <div className="container-fluid">
                            <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
                                <RiErrorWarningLine className="text-danger fs-1 mb-3" />
                                <p className="text-danger fw-bold">{error}</p>
                                <button onClick={fetchData} className="btn btn-primary mt-2">Try Again</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <Topbar />
            <Sidebar />

            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                                        <div>
                                            <h4 className="mb-0 fw-bold">Run Payroll</h4>
                                            <small className="text-muted">Generate and manage employee payroll</small>
                                        </div>
                                        <div className="d-flex gap-3 align-items-center">
                                            <div className="d-flex align-items-center gap-2">
                                                <label className="mb-0 text-muted small fw-bold">Month:</label>
                                                <input
                                                    type="month"
                                                    className="form-control form-control-sm"
                                                    value={selectedMonth}
                                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                                    style={{ width: '160px' }}
                                                />
                                            </div>
                                            <div className="input-group" style={{ width: '300px' }}>
                                                <span className="input-group-text bg-light-subtle border-end-0">
                                                    <RiSearchLine className="text-muted" />
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control bg-light-subtle border-start-0"
                                                    placeholder="Search employees..."
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <button
                                                className="btn btn-primary d-flex align-items-center gap-3"
                                                onClick={handleRunPayroll}
                                                disabled={runPayrollLoading}
                                                style={{ marginLeft: '12px' }}
                                            >
                                                {runPayrollLoading ? (
                                                    <RiLoader4Line className="spinner-border spinner-border-sm" style={{ border: 'none', animation: 'spin 1s linear infinite' }} />
                                                ) : <RiPlayFill />}
                                                {runPayrollLoading ? 'Processing...' : 'Run Payroll'}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <div className="table-responsive custom--scrollbar">
                                            <table className="table table-hover align-middle text-nowrap w-100">
                                                <thead className="bg-light-subtle">
                                                    <tr>
                                                        <th className="py-3 px-4">Employee</th>
                                                        <th className="py-3">Department</th>
                                                        <th className="py-3">Position</th>
                                                        <th className="py-3">Monthly Basic</th>
                                                        <th className="py-3 text-end px-4">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredEmployees.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="5" className="text-center py-5">
                                                                <div className="text-muted">
                                                                    <RiUserLine className="fs-1 mb-2 d-block mx-auto" />
                                                                    <p>No employees found matching your search.</p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        filteredEmployees.map(employee => (
                                                            <tr key={employee.id}>
                                                                <td className="px-4">
                                                                    <div className="d-flex align-items-center gap-3">
                                                                        <div className="avatar avatar-sm bg-primary-light text-primary rounded-circle d-flex align-items-center justify-content-center fw-bold">
                                                                            {(employee.first_name?.[0] || '') + (employee.last_name?.[0] || '')}
                                                                        </div>
                                                                        <div>
                                                                            <h6 className="mb-0 fw-bold">{employee.first_name} {employee.last_name}</h6>
                                                                            <small className="text-muted">{employee.email}</small>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span className="badge bg-light-subtle text-dark fw-normal px-2 py-1">
                                                                        {employee.department?.name || 'N/A'}
                                                                    </span>
                                                                </td>
                                                                <td>{employee.position || 'N/A'}</td>
                                                                <td className="fw-bold">
                                                                    ${parseFloat(employee?.basic_salary)}
                                                                </td>
                                                                <td className="text-end px-4">
                                                                    <div className="d-flex justify-content-end gap-2">
                                                                        <button
                                                                            className="btn btn-sm btn-light-primary"
                                                                            title="View Details"
                                                                            onClick={() => navigate(`/hr/employee/${employee.id}/payroll-review`)}
                                                                        >
                                                                            <RiEye2Line />
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                .bg-primary-light { background-color: rgba(13, 110, 253, 0.1); }
                .btn-light-primary { color: #0d6efd; background-color: rgba(13, 110, 253, 0.1); border: none; }
                .btn-light-primary:hover { color: #fff; background-color: #0d6efd; }
                .btn-light-info { color: #0dcaf0; background-color: rgba(13, 202, 240, 0.1); border: none; }
                .btn-light-info:hover { color: #fff; background-color: #0dcaf0; }
                @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
            `}</style>
        </div>
    )
}

export default RunPayroll
